import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'
import { _searchTileContainerQueryUp } from './_MetaSearchTileBase'

const Container = styled.div`
  grid-area: content-secondary;
  display: flex;
  flex-direction: row;
  gap: ${rem(16)};
  justify-content: flex-start;
  width: 100%;

  & > * {
    flex: 1;
  }

  ${_searchTileContainerQueryUp.tablet} {
    justify-content: flex-end
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    justify-content: flex-start;
  }

  ${_searchTileContainerQueryUp.desktopLarge} {
    justify-content: flex-end;
  }
`

interface Props extends PropsWithChildren {
  callToAction?: ReactElement
}

function _MetaSearchTileContentSecondary({
  children,
}: Props) {
  return <Container className={_MetaSearchTileContentSecondary.name}>
    {children}
  </Container>
}

export default _MetaSearchTileContentSecondary
